<template lang="pug">
.v-bg-banner.bg-banner(v-if="banner")
	.bg-banner__container.container
		.bg-banner__wrap
			.bg-banner__left
				img.bg-banner__image(v-if="banner.image" ref="image" :src="banner.image" alt="")
				template(v-if="isMd")
					.bg-banner__slider-wrap
						v-swiper-slider.bg-banner__slider(:options="options"
								:navigation="navigation"
								:scrollbar="scrollbar"
								swiper-class-name="brands-slider__swiper")
							swiper-slide.bg-banner__slide(v-if="banner.itemsTitle")
								.bg-banner__item.bg-banner__item--title
									.bg-banner__item-title {{banner.itemsTitle}}
							swiper-slide.bg-banner__slide(v-for="(item, index) in banner.items" :key="index")
								.bg-banner__item-wrap
									.bg-banner__item
										.bg-banner__item-icon-wrap
											.bg-banner__item-number 0{{index + 1}}
											v-svg-icon.bg-banner__item-icon(:icon="item.icon")
										.bg-banner__item-title(v-if="item.title" v-html="item.title")
										.bg-banner__item-text.flc(v-if="item.text" v-html="item.text")
				template(v-else)
					.bg-banner__items-title(v-if="banner.itemsTitle") {{banner.itemsTitle}}
					.bg-banner__items(v-if="banner.items && banner.items.length")
						template(v-for="(item, index) in banner.items" :key="index")
							.bg-banner__item
								.bg-banner__item-icon-wrap
									.bg-banner__item-number 0{{index + 1}}
									v-svg-icon.bg-banner__item-icon(:icon="item.icon || 'flower'")
								.bg-banner__item-title(v-if="item.title" v-html="item.title")
								.bg-banner__item-text.flc(v-if="item.text" v-html="item.text")
			.bg-banner__right
				.bg-banner__right-top
					.bg-banner__supertitle(v-if="banner.supertitle")
						v-svg-icon.bg-banner__supertitle-icon(:icon="banner.icon || 'flower'")
						.bg-banner__supertitle-text {{banner.supertitle}}
					h2.bg-banner__title.flc(v-if="banner.title" v-html="banner.title")
					span.bg-banner__subtitle.flc(v-if="banner.subtitle" v-html="banner.subtitle")
					.bg-banner__text-wrap(v-if="banner.text || banner.link" )
						.bg-banner__text.flc(v-if="banner.text" v-html="banner.text" )
						.bg-banner__action.flc(v-if="banner.link")
							a.bg-banner__link.btn.btn--has-right-icon.btn--primary(:href="banner.link.link" :class="{'btn--wide': isMd}")
								.btn__text {{banner.link.text}}
								.btn__icon-wrap
									v-svg-icon.btn__icon.btn__icon--original(icon="arrow-top-right")
									v-svg-icon.btn__icon.btn__icon--copy(icon="arrow-top-right")
					.bg-banner__list.flc(v-if="banner.list")
						.bg-banner__list-item(v-for="(item, index) in banner.list" :key="index" )
							.bg-banner__list-item_title(v-if="item.title") {{item.title}}
							.bg-banner__list-item_text(v-if="item.text") {{item.text}}
				.bg-banner__right-bottom(v-if="banner.features")
					.bg-banner__features
						.bg-banner__features-title(v-if="banner.features.title") {{banner.features.title}}
						.bg-banner__features-items.flc(v-if="banner.features.items && banner.features.items.length")
							template(v-for="(featuresItem, featuresItemIndex) in banner.features.items" :key="featuresItemIndex")
								.bg-banner__features-col
									.bg-banner__features-item
										v-svg-icon.bg-banner__features-item-icon(:icon="featuresItem.icon || 'flower'")
										.bg-banner__features-item-main
											.bg-banner__features-item-title(v-if="featuresItem.title") {{featuresItem.title}}
											.bg-banner__features-item-text(v-if="featuresItem.text") {{featuresItem.text}}
						.bg-banner__features-text.flc(v-if="banner.features.text") {{banner.features.text}}

				.bg-banner__right-bottom-bonus(v-else-if="banner.bonus && (!banner.bonus.type || banner.bonus.type !== 'inline')" :class="`bg-banner__right-bottom-bonus--${banner.bonus.bgColor}`")
					.bg-banner__right-bottom-bonus_supertitle
						v-svg-icon.bg-banner__right-bottom-bonus_icon(v-if="banner.bonus.icon" :icon="banner.bonus.icon" :class="`bg-banner__right-bottom-bonus_icon--${banner.bonus.iconBgColor}`")
						.bg-banner__right-bottom-bonus_supertitle-text(v-if="banner.bonus.supertitle") {{ banner.bonus.supertitle }}
					.bg-banner__right-bottom-bonus_title(v-if="banner.bonus.title") {{ banner.bonus.title }}
					.bg-banner__right-bottom-bonus_text(v-if="banner.bonus.text") {{ banner.bonus.text }}

				.bg-banner__right-bottom-bonus(v-else-if="banner.bonus && banner.bonus.type === 'inline'" :class="[`bg-banner__right-bottom-bonus--${banner.bonus.bgColor}`, banner.bonus.type || ``]")
					v-svg-icon.bg-banner__right-bottom-bonus_icon(v-if="banner.bonus.icon" :icon="banner.bonus.icon" :class="`bg-banner__right-bottom-bonus_icon--${banner.bonus.iconBgColor}`")
					.bg-banner__right-bottom-bonus_text(v-if="banner.bonus.text" ) {{banner.bonus.text}}




</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from "../scripts/controller/controller.js";
import uniqueId from '../scripts/helpers/uniqueId.js';
import {SwiperSlide} from "swiper/vue";

export default {
	components: {
		SwiperSlide,
	},

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			banner: null,
			uniqueId: uniqueId('swiper-'),
			options: {
				slidesPerView: 'auto',
				spaceBetween: 1
			},
			navigation: false,
			scrollbar: {
				draggable: true
			}
		};
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	mounted() {
		const isVisible = window.scrollY + window.innerHeight > this.$el?.offsetTop;
		let $image = this.$refs['image'];
		// console.log('mounted', $image, window.scrollY, window.innerHeight,this.$el?.offsetTop)
		if (!$image) return;

		if (isVisible) {
			$image.style.zIndex = '-2';
			$image.style.opacity = '1';
		} else {
			$image.style.zIndex = '-4';
			$image.style.opacity = '0';
		}
	},

	methods: {
		handleScroll() {
			const logoHeight = 80;
			const logoOffset = 48;
			let $image = this.$refs['image'];
			if (!$image) return;

			if (window.scrollY > this.$el?.offsetTop - 48 && (window.scrollY < this.$el?.offsetHeight + this.$el?.offsetTop + logoHeight - logoOffset)) {
				document.body.classList.remove('state--page-header-blackout');
			}

			const isVisible = window.scrollY + window.innerHeight > this.$el?.offsetTop;

			if (isVisible) {
				$image.style.zIndex = '-2';
				$image.style.opacity = '1';
			} else {
				$image.style.zIndex = '-4';
				$image.style.opacity = '0';
			}
		},

		dataSet(data) {
			this.banner = data;
			this.handleScroll();

			const route = window.location;
			const iconsForMainPageLeft = ['cheese-6', 'hands', 'logic']
			const iconsForMainPageRight = ['grand-2', 'planet-5', 'planet-2']

			if (route.pathname === '/') {

				this.banner.items.map((item, index) => {
					item.icon = iconsForMainPageLeft[index];
				});
				this.banner.features.items.map((item, index) => {
					item.icon = iconsForMainPageRight[index];
				});
			}

			window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		}
	}
};
</script>
